{
    "all": "All",
    "pendingFeesHeading": "Pending fees",
    "filterBy": "Filter By :",
    "report": "Reports / ",
    "export": "Export",
    "wing": "Wing : ",
    "section": "Section : ",
    "gender": "Gender :",
    "reset": "Reset",
    "moreFilter": "More filter",
    "show": "Show results",
    "lessFilter": "Less filter",
    "resultAvailable": " results available.",
    "apply": "Apply",
    "exportReport": "Export report",
    "exportFirstMessage": "You will export this report, and it will be sent to all super admins.",
    "exportSecondMessage": "If you wish to send the report to a different email, please enter the email address.",
    "noData": "No data available.",
    "error": "Error",
    "errorExport": "Error in export report",
    "somethingWentWrong": "Something went wrong.",
    "selectWing": "Select wing",
    "selectSection": "Select section",
    "selectClass": "Select class",
    "selectGender": "Select gender",
    "reportType": "CATEGORY_WISE",
    "reportFormat": "Excel",
    "searchStudentLabel": "Search student",
    "searchStudentPlacegholder": "Search student",
    "chooseAcademicYearLabel": "Choose academic year",
    "currentYearText": "(Current year)",
    "defaultErrorMessage": "Something went wrong.",
    "errorCode": "error",
    "successCode": "success",
    "attendance": "Attendance",
    "filter": "Filter by :",
    "class": "Class :",
    "date": "Date :",
    "selectedStudent": "Selected student :",
    "selectDate": "Select date",
    "selectStudent": "Select student",
    "applyFilter": "Apply filter",
    "attendanceMarked": "Attendance marked",
    "attendanceNotMarked": "Attendance not marked",
    "feeCollected": "Fee collected",
    "feePending": "Fee pending",
    "showResult": "Show result ",
    "dataNotAvailable": "Data not available",
    "dataNotAvailableSecond": "Sorry, we couldn’t find any data for the applied filter.",
    "selectAll": "All",
    "searchStuduentPlaceholder": "Search student's",
    "selectedStudentText":" student(s) selected"
}